import { IResponse } from "models";

export enum ActionType {
  GET_BREAKFAST_CHART = "action/GET_BREAKFAST_CHART",
  GET_BREAKFAST_CHART_SUCCESS = "action/GET_BREAKFAST_CHART_SUCCESS",
  GET_BREAKFAST_CHART_ERROR = "action/GET_BREAKFAST_CHART_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface BreakfastPayload {
  aggregate_date_to: string;
  aggregate_date_from?: string;
  //   department_id: number | string;
  department_id: any;
}

export interface AbsenceResponse extends IResponse {
  breakfast: any;
  total_amount: number;
}
